import {paginatedListAction} from '@/vuex/paginatedListAction';
import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const addNotificationSuccess = (err) => {
    notification.success({
        message: err,
    });
};

const state = () => ({
    areaListQuery: {},
    listQuery: {},
    timeBlocks: [],
    leads: [],
    areas: [],
    lead: {},
    area: {},
    loadingAssign: false,
    loadingTimeBlocks: false,
    loadingLeads: false,
    loadingAreaCreate: false,
    loadingTimeBlockCreate: false,
    loadingAreas: false,
    loadingArea: false,
    loadingLead: true,
    count: 0,
    currentPage: 1,
    pageSize: 10,
    countArea: 0,
    currentPageArea: 1,
    pageSizeArea: 10,
    countTimeBlocks: 0,
    currentPageTimeBlocks: 1,
    pageSizeTimeBlocks: 10,
});

const actions = {
    getLeads: paginatedListAction({endpoint: '/leads', prefix: 'leadsData'}),
    getAreas: paginatedListAction({endpoint: '/leadareas', prefix: 'areasData', queryKey: 'areaListQuery', pageKey: 'currentPageArea', sizeKey: 'pageSizeArea'}),
    async getTimeBlocks({commit, state}, input) {
        const data = typeof input === 'object' ? input : {id: input, page: 1};
        const query = {page: state.currentPageTimeBlocks, pageSize: state.pageSizeTimeBlocks, ...data};
        try {
            await commit('timeBlocksDataBegin');
            const response = await DataService.get(`leadareas/${data.id}/timeblocks`, query);
            await commit('timeBlocksDataSuccess', response.data);
        } catch (err) {
            await commit('timeBlocksDataErr');
            addNotificationError(err?.response?.data?.message);
        }
    },
    async createTimeBlock({commit, dispatch}, data) {
        try {
            await commit('timeBlockCreateDataBegin');
            const response = await DataService.post(`leadareas/${data.value.leadAreaID}/timeblocks`, data.value);
            await commit('timeBlockCreateDataSuccess', response.data);
            addNotificationSuccess('Tijdsblok is met succes aangemaakt.');
            await dispatch('getTimeBlocks', data.value.leadAreaID);
            data.close();
        } catch (err) {
            await commit('timeBlockCreateDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    async assignLeads({commit, dispatch}, data) {
        try {
            await commit('assignLeadsDataBegin');
            const response = await DataService.post(`/leads/massassign`, data.values);
            await commit('assignLeadsDataSuccess', response.data);
            addNotificationSuccess('De geselecteerde leads zijn toegewezen.');
            await dispatch('getLeads');
            data.close();
        } catch (err) {
            await commit('assignLeadsDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    async createArea({commit, dispatch}, data) {
        try {
            await commit('areasCreateDataBegin');
            const response = await DataService.post(`leadareas`, data.value);
            await commit('areasCreateDataSuccess', response.data);
            addNotificationSuccess('Gebied is met succes aangemaakt.');
            await dispatch('getAreas');
            data.close();
        } catch (err) {
            await commit('areasCreateDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    async getLead({commit}, id) {
        try {
            await commit('leadDataBegin');
            const response = await DataService.get(`/leads/${id}`);
            await commit('leadDataSuccess', response.data);
        } catch (err) {
            await commit('leadDataErr');
            addNotificationError(err?.response?.data?.message);
        }
    },
    async getArea({commit}, id) {
        try {
            await commit('areaDataBegin');
            const response = await DataService.get(`/leadareas/${id}`);
            await commit('areaDataSuccess', response.data);
        } catch (err) {
            await commit('areaDataErr');
            addNotificationError(err?.response?.data?.message);
        }
    },
    async setCurrentPageLeads({commit}, page) {
        await commit('setCurrentPageLeads', page);
    },
    async setCurrentPageAreas({commit}, page) {
        await commit('setCurrentPageAreas', page);
    },
    async setCurrentPageTimeBlocks({commit}, page) {
        await commit('setCurrentPageTimeBlocks', page);
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
